import Events from '../events'
import EventBus from '../event-bus'
import Logger from '../../logger'
import { LogoTracker, LTEvents } from '~/lib/events/tracker'
import { normalizeString } from '~/lib/constants/patterns'

EventBus.$on(Events.AppWordmarkUpdated, async wordmark => {
  Logger.debug(`Handling event: ${Events.AppWordmarkUpdated}: ${wordmark}`)

  EventBus.$emit(Events.AnalyticsGA4Event, {
    event: 'wordmark_updated',
    wordmark,
  })
})

EventBus.$on(Events.AppSloganUpdated, async slogan => {
  Logger.debug(`Handling event: ${Events.AppSloganUpdated}: ${slogan}`)

  EventBus.$emit(Events.AnalyticsGA4Event, {
    event: 'slogan_updated',
    slogan,
  })
})

EventBus.$on(Events.UserOpenDashboardUpgradeModal, ({ referring_product }) => {
  LogoTracker.track(LTEvents.UPGRADE_MODAL_LAUNCHED, {
    referring_product,
  })
})

EventBus.$on(
  Events.OnePageSitePublished,
  ({ subdomain, theme, links, custom_domain, social_icon_type }) => {
    const subdomainUrl = `${subdomain}.hi.link`

    LogoTracker.track(LTEvents.ONE_PAGE_PUBLISHED, {
      one_page_link: custom_domain || subdomainUrl,
      one_page_total_links: links.length,
      one_page_theme: theme,
      one_page_social_style: social_icon_type,
    })
  }
)

EventBus.$on(Events.StitchVisit, ({ feature, logo }) => {
  LogoTracker.track(LTEvents.STITCH_OPENED, {
    feature,
  })

  EventBus.$emit(Events.AnalyticsGA4Event, {
    event: 'stitch_visit',
    feature,
    logo,
  })
})

EventBus.$on(Events.OnePageSiteEditorVisited, () => {
  LogoTracker.track(LTEvents.ONE_PAGE_EDITED)
})

EventBus.$on(Events.OnePageSiteVisited, () => {
  LogoTracker.track(LTEvents.ONE_PAGE_OPENED)
})

EventBus.$on(
  Events.OnePageSiteCreateCustomDomain,
  ({ one_page_link, purchase_source }) => {
    LogoTracker.track(LTEvents.ONE_PAGE_CUSTOM_DOMAIN_ADDED, {
      one_page_link,
      purchase_source,
    })
  }
)

EventBus.$on(Events.BNGSearched, ({ search_term = [] }) => {
  EventBus.$emit(Events.AnalyticsSearch, {
    type: 'Business Name Generator',
    search_term: search_term.join(' '),
  })

  LogoTracker.track(LTEvents.BNG_SEARCHED, {
    search_term: search_term.map(normalizeString),
  })
})

EventBus.$on(Events.BNGSelected, ({ search_term = [], business_name }) => {
  LogoTracker.track(LTEvents.BNG_SELECTED, {
    search_term: search_term.map(normalizeString),
    business_name,
  })
})

EventBus.$on(Events.BNGFavourited, ({ search_term = [], business_name }) => {
  LogoTracker.track(LTEvents.BNG_FAVOURITED, {
    search_term: search_term.map(normalizeString),
    business_name,
  })
})

EventBus.$on(Events.PlanCancellationPageOpened, ({ plan_type }) => {
  LogoTracker.track(LTEvents.CANCEL_PAGE_OPENED, {
    plan_type,
  })
})
EventBus.$on(Events.PlanCancellationRequested, ({ plan_type }) => {
  LogoTracker.track(LTEvents.CANCEL_PAGE_CONFIRMED, {
    plan_type,
  })
})

EventBus.$on(Events.PlanReactivated, ({ plan_type }) => {
  LogoTracker.track(LTEvents.PLAN_REACTIVATED, {
    plan_type,
  })
})

EventBus.$on(Events.EditorIdeasPageOpened, payload => {
  LogoTracker.track(LTEvents.IDEAS_PAGE_OPENED, payload)
})

EventBus.$on(Events.LogoEditorOpened, payload => {
  LogoTracker.track(LTEvents.LOGO_EDITOR_OPENED, payload)
})
